<vp-header
	[editableInStoryblok]="_editable"
	[menuItems]="headerMenu"
	[metaMenu]="metaMenu"
	[title]="title"
	(languageSwitch)="onLanguageSwitch($event)"
/>
